import { endOfMonth, startOfDay, startOfMonth, subMonths } from "date-fns";
import { getToday } from "@/utils/dates/dateUtils";

const LAST_MONTH_EDIT_LIMIT_DAY = 15;

interface WorksheetEditingPolicy {
  readonly referenceDate: Date;
  readonly canEditPreviousMonth: boolean;
  readonly currentMonthStart: Date;
  readonly previousMonthStart: Date;
  readonly previousMonthEnd: Date;
  readonly minDate: Date;
}

export function getWorksheetEditingPolicy(referenceDate: Date = getToday()): WorksheetEditingPolicy {
  const normalizedReferenceDate = startOfDay(referenceDate);
  const canEditPreviousMonth = normalizedReferenceDate.getDate() <= LAST_MONTH_EDIT_LIMIT_DAY;

  const currentMonthStart = startOfMonth(normalizedReferenceDate);
  const previousMonthDate = subMonths(normalizedReferenceDate, 1);
  const previousMonthStart = startOfMonth(previousMonthDate);
  const previousMonthEnd = endOfMonth(previousMonthDate);

  const minDate = canEditPreviousMonth ? previousMonthStart : currentMonthStart;

  return {
    referenceDate: normalizedReferenceDate,
    canEditPreviousMonth,
    currentMonthStart,
    previousMonthStart,
    previousMonthEnd,
    minDate,
  };
}
